import React, { useEffect, useState } from 'react'
import { Alert, Card, Col, Container, Row } from 'react-bootstrap'
import MyAccountNav from '../components/MyAccountNav'
import { useLocation, useNavigate } from 'react-router-dom';
import CustomerAPI from '../API/customerAPI';
import CustomerObj from '../features/customer/customerObj';
import { useDispatch, useSelector } from 'react-redux';
import { resetCustomer, selectCustomer } from '../features/customer/customerSlice';
import Loader from '../components/Loader';
import { selectIsMobileRoute } from '../features/mobile/mobileSlice';

export default function CustomerMemberShip() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const customer = new CustomerObj(useSelector(selectCustomer));
    const AppURL = useSelector(selectIsMobileRoute);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<JSX.Element | null>(null);
    const urlParams = new URLSearchParams(location.search);
    const authCode = urlParams.get('code');
    const QURLParams = AppURL ? `/?${AppURL}` : '/';

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                if (authCode && customer?.data?.id) {
                    const response = await CustomerAPI.customerMembership(customer.data.id, 163664, authCode);
                    if (response.status === 200) {
                        await dispatch(resetCustomer());
                        navigate(`/my-account${QURLParams}`);
                    } else if (response.status === 403) {
                        setErrorMessage(
                            <>
                                <strong>We could not verify your eligibility for the Military or First Responder discount. </strong>
                                <br />
                                If you believe this is an error, please try again or&nbsp;
                                <a href="https://mightymeals.freshdesk.com/support/tickets/new" target="_blank" rel="noopener noreferrer">
                                    contact our support team for assistance
                                </a>.
                            </>
                        );
                    } else {
                        setErrorMessage(
                            <>
                                <strong>Your verification session has expired or was revoked.</strong>
                                <br />
                                Please try again, or&nbsp;
                                <a href="https://mightymeals.freshdesk.com/support/tickets/new" target="_blank" rel="noopener noreferrer">
                                    verify manually here
                                </a>.
                            </>
                        );
                    }
                }
            } catch (error) {
                console.error('Failed to add membership:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authCode, customer?.data?.id]);

    return (
        <Container fluid="lg" className='address-page'>
            <Row>
                <Col sm={12} md={3}>
                    <MyAccountNav />
                </Col>
                <Col sm={12} md={9} className='d-flex flex-column'>
                    <Card body className="my-memberships my-5 flex-fill p-4 text-center bg-light">
                        <h2 className="mb-3">Military & First Responder Discount</h2>
                        <p className="text-muted mb-4" style={{ fontSize: '1.1rem' }}>
                            We proudly support our heroes. Verify your status to unlock exclusive savings.
                        </p>
                        {isLoading &&
                            <div className='text-center my-5 h-100'>
                                <Loader />
                            </div>}
                        {errorMessage && <Alert variant="danger" className="my-3">{errorMessage}</Alert>}
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}